// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EFo5S","label":"styles_label__1ynzM"};